"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_error_boundary_1 = require("react-error-boundary");
var ErrorBoundary = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement(react_error_boundary_1.ErrorBoundary, { fallbackRender: function (_a) {
            var error = _a.error;
            return (react_1.default.createElement("div", { className: "flex flex-col items-center justify-center" },
                react_1.default.createElement("h2", { className: "text-red-600" }, "Something went wrong"),
                react_1.default.createElement("p", { className: "mt-6 text-xs text-gray-600" }, error)));
        } }, children));
};
exports.default = ErrorBoundary;
//# sourceMappingURL=error-boundary.js.map